import * as types from 'reducer/actionTypes'
import { isEmpty } from 'script/common';

const initialState = {
	search:{
		startDate:new Date().toISOString().slice(0,10),
		endDate:new Date().toISOString().slice(0,10),
		optionPeriod: 0,
	},
	condition:{
		pagination: {
			current: 1,
			pageSize: 10,
			total: 0,
			pagingStart: 0
		},
		orderby: {
			columnKey: "date",
			order: "desc"
		},
	},
	summaryCsv:[],
	summaryTotal:[{}],
	summaryInfo:[],
	errorLabel:null,
	error:null
};

export default function stats(state = initialState, action){
	switch(action.type){
		case types.SET_STATS_ERRORLABEL :
			return{
				...state,
				errorLabel: action.errorLabel
			}

		case types.SET_STATS_OPTION_PERIOD :
			return{
				...state,
				search: {
					...state.search,
					optionPeriod: action.value,
				},
				errorLabel: null
			}
			
		case types.SET_STATS_STARTDATE :
			return{
				...state,
				search: {
					...state.search,
					startDate: action.startDate,
				},
				errorLabel: null
			}
		
		case types.SET_STATS_ENDTDATE :
			return{
				...state,
				search: {
					...state.search,
					endDate: action.endDate,
				},
				errorLabel: null
			}

		case types.SET_STATS_CONDITION :
			return{
				...state,
				condition: isEmpty(action.condition) ? initialState.condition : action.condition,
			}

		case types.SET_STATS_SUMMARY_TOTAL :
		return{
				...state,
				summaryTotal: action.value,
				condition: {
					...state.condition,
					pagination: {
						...state.condition.pagination,
					}
				}
			}

		//fetch
		case types.FETCH_GET_STATS_SUMMARY_INFO_SUCCESS :
			return{
				...state,
				summaryInfo: action.value,
				condition: action.condition,
				error: initialState.error
			}

		case types.FETCH_GET_STATS_SUMMARY_CSV_SUCCESS :
			return{
				...state,
				summaryCsv: action.value,
				error: initialState.error
			}

		case types.FETCH_GET_STATS_SUMMARY_INFO_FAILURE :
			return{
				...state,
				error: action.error
			}
		
		default:
			return state
	}
}